const Banner = () => {
  
  return (
    <div className="py-8">
      <img src="/images/banner.webp" alt="img" />
    </div>
  );
};

export default Banner;